import PermissionsProvider from './permissions-provider';

export * from './use-permissions';

export default PermissionsProvider;
